/**
 * Placement Overview tab component with time series chart.
 */

import { useState } from 'react';
import { useTimeSeries } from '@/hooks/useAnalytics';
import { TimeSeries } from '@/components/charts/time-series';
import { LoadingSpinner } from '@/components/ui/loading';
import { Card } from '@/components/ui/card';
import './overview.scss';

interface PlacementOverviewProps {
  placementId: string;
}

export function PlacementOverview({ placementId }: PlacementOverviewProps) {
  const [interval, setInterval] = useState<'1h' | '1d' | '1w'>('1h');
  const { data, isLoading, error } = useTimeSeries(placementId, { interval });

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <LoadingSpinner />
      </div>
    );
  }

  if (error) {
    return (
      <Card>
        <p className="of-text-muted">Error loading time series data</p>
      </Card>
    );
  }

  return (
    <div className="placement-overview">
      <div className="placement-overview__controls">
        <label htmlFor="interval-select" className="label">
          Interval
        </label>
        <select
          id="interval-select"
          value={interval}
          onChange={(e) => setInterval(e.target.value as '1h' | '1d' | '1w')}
          className="select"
        >
          <option value="1h">Hourly</option>
          <option value="1d">Daily</option>
          <option value="1w">Weekly</option>
        </select>
      </div>
      <Card>
        <h3 className="h3" style={{ marginBottom: 'var(--of-space-4)' }}>
          Click Activity
        </h3>
        <TimeSeries data={data?.series || []} />
      </Card>
    </div>
  );
}

